import { inject, Injectable, OnDestroy, OnInit } from '@angular/core';
import { Subject, BehaviorSubject, fromEvent } from 'rxjs';
import { takeUntil, debounceTime } from 'rxjs/operators';

import { Router } from '@angular/router';
import { CognitoService } from '../auth/cognito.service';
import { Store } from '@ngrx/store';
import { selectLoggedUser } from '../../store/logged_user/logged_user.selectors';
import { User } from '../../models/user.model';
// Menu
export interface Menu {
  headTitle?: string;
  headTitle2?: string;
  path?: string;
  dirchange?: boolean;
  title?: string;
  icon?: string;
  type?: string;
  badgeValue?: string;
  badgeClass?: string;
  active?: boolean;
  selected?: boolean;
  bookmark?: boolean;
  children?: Menu[];
  Menusub?: boolean;
  target?: boolean;
  menutype?: string;
}

@Injectable({
  providedIn: 'root',
})
export class NavService implements OnDestroy {
  private unsubscriber: Subject<any> = new Subject();
  public screenWidth: BehaviorSubject<number> = new BehaviorSubject(
    window.innerWidth
  );

  // Search Box
  public search = false;

  // Language
  public language = false;

  // Mega Menu
  public megaMenu = false;
  public levelMenu = false;
  public megaMenuColapse: boolean = window.innerWidth < 1199 ? true : false;

  // Collapse Sidebar
  public collapseSidebar: boolean = window.innerWidth < 991 ? true : false;

  // For Horizontal Layout Mobile
  public horizontal: boolean = window.innerWidth < 991 ? false : true;

  // Full screen
  public fullScreen = false;
  active: any;

  constructor(private router: Router) {
    this.setScreenWidth(window.innerWidth);
    fromEvent(window, 'resize')
      .pipe(debounceTime(1000), takeUntil(this.unsubscriber))
      .subscribe((evt: any) => {
        this.setScreenWidth(evt.target.innerWidth);
        if (evt.target.innerWidth < 991) {
          this.collapseSidebar = true;
          this.megaMenu = false;
          this.levelMenu = false;
        }
        if (evt.target.innerWidth < 1199) {
          this.megaMenuColapse = true;
        }
      });
    if (window.innerWidth < 991) {
      // Detect Route change sidebar close
      this.router.events.subscribe((event) => {
        this.collapseSidebar = true;
        this.megaMenu = false;
        this.levelMenu = false;
      });
    }
  }

  ngOnDestroy() {
    this.unsubscriber.next;
    this.unsubscriber.complete();
  }

  private setScreenWidth(width: number): void {
    this.screenWidth.next(width);
  }

  //! ELEMENTI DEL MENU
  private cognitoService = inject(CognitoService);
  private store = inject(Store);
  adminRoutes: Menu[] = [];
  userRoutes: Menu[] = [];

  setupMenu() {
    this.store.select(selectLoggedUser)
    .pipe(
      takeUntil(this.unsubscriber)
    )
    .subscribe(data => {
      if(data) {
        const loggedUser = data as User;

        if(loggedUser.role) {
          this.MENUITEMS = [];
          this.items.next(this.MENUITEMS);
        }

        if(loggedUser.role === 'ADMIN') {
          this.adminRoutes = [
            // BOLLETTE
            { headTitle: 'BOLLETTE' },
            {
              title: 'Bollette',
              icon: 'bi-receipt',
              dirchange: false,
              type: 'sub',
              active: false,
              selected: false,
              path: '/bollette',
              children: [
                // Estrazione dati
                {
                  title: 'Estrazione dati',
                  icon: 'bi-receipt',
                  dirchange: false,
                  type: 'link',
                  active: false,
                  selected: false,
                  path: '/bollette/estrazione-dati',
                },
                // RETE COMMERCIALE
                {
                  title: 'Rete commerciale',
                  icon: 'bi-link-45deg',
                  dirchange: false,
                  type: 'link',
                  active: false,
                  selected: false,
                  path: '/bollette/rete-commerciale',
                },
              ]
            },
            // CURVE DI CARICO
            { headTitle: 'CURVE DI CARICO' },
            {
              title: 'Curve di carico',
              icon: 'bi-lightning',
              dirchange: false,
              type: 'sub',
              active: false,
              children: [
                {
                  title: 'Clienti',
                  dirchange: false,
                  type: 'link',
                  active: false,
                  selected: false,
                  path: '/curve-di-carico/clienti',
                }
              ]
            },
            // CHATBOT
            { headTitle: 'CHATBOT' },
            {
              title: 'Chatbot',
              icon: 'bi-chat-dots',
              dirchange: false,
              type: 'link',
              active: false,
              selected: false,
              path: '/chatbot',
            },
            // UTENTI
            { headTitle: 'UTENTI' },
            {
              title: 'Utenti',
              icon: 'bi-people',
              dirchange: false,
              type: 'link',
              active: false,
              selected: false,
              path: '/utenti',
            },
          ]

          this.MENUITEMS = this.adminRoutes;
          this.items.next(this.MENUITEMS);
        }
        else {
          this.userRoutes = [
            // BOLLETTE
            { headTitle: 'BOLLETTE' },
            {
              title: 'Bollette',
              icon: 'bi-receipt',
              dirchange: false,
              type: 'sub',
              active: false,
              selected: false,
              path: '/bollette',
              children: [
                // Estrazione dati
                {
                  title: 'Estrazione dati',
                  icon: 'bi-receipt',
                  dirchange: false,
                  type: 'link',
                  active: false,
                  selected: false,
                  path: '/bollette/estrazione-dati',
                },
              ]
            },
            // CURVE DI CARICO
            { headTitle: 'CURVE DI CARICO' },
            {
              title: 'Curve di carico',
              icon: 'bi-lightning',
              dirchange: false,
              type: 'sub',
              active: false,
              children: [
                {
                  title: 'Clienti',
                  dirchange: false,
                  type: 'link',
                  active: false,
                  selected: false,
                  path: '/curve-di-carico/clienti',
                }
              ]
            },
            // CHATBOT
            { headTitle: 'CHATBOT' },
            {
              title: 'Chatbot',
              icon: 'bi-chat-dots',
              dirchange: false,
              type: 'link',
              active: false,
              selected: false,
              path: '/chatbot',
            }
          ]

          this.MENUITEMS = this.userRoutes;
          this.items.next(this.MENUITEMS);
        }
      }
    })
  }

  MENUITEMS: Menu[] = [];

  // Array
  items = new BehaviorSubject<Menu[]>(this.MENUITEMS);
}
